import React, { useState, useEffect } from "react";
import { axiosPost } from "../../services/axios/apiCalls"

const CookieNoticeContainer = () => {
    const STORAGE_KEY = "cookiesAccepted";
    const [visible, setVisible] = useState(false);
    const [detailsVisible, setDetailsVisible] = useState(false);
    const [detailsBtnText, setDetailsBtnText] = useState('Más info');
    const [cookiesData, setCookiesData] = useState({});

    const getcookiesData = async () => {
        try {
            const response = await axiosPost("/public/content/get/cookies", null, {}, { withCredentials: true })
            return response.data
        } catch (error) {
        }
    }

    useEffect(() => {
        const fetchData = async () => {
            setCookiesData(await getcookiesData())
        }
        const accepted = localStorage.getItem(STORAGE_KEY) === "true";
        setVisible(!accepted);
        fetchData()
    }, []);

    const handleAccept = () => {
        localStorage.setItem(STORAGE_KEY, "true");
        setVisible(false);
    };

    const handleInfo = () => {
        if (detailsVisible) {
            setDetailsVisible(false)
            setDetailsBtnText('Más info')
        } else {
            setDetailsVisible(true)
            setDetailsBtnText('Menos info')
        }
    };

    if (!visible) return null;

    return (
        <div className="container-xxl info-panel position-fixed bottom-0 start-0 end-0 bg-light shadow-lg p-3 d-flex justify-content-between align-items-center z-3" >
            <p className="mb-0 flex-grow-1 pe-3 text-dark fs-6" style={styles.text}>
                {!detailsVisible && cookiesData.cookiesShort}
                {detailsVisible && cookiesData.cookiesNotice}
            </p>
            <button className="btn-navbar me-2"  onClick={handleInfo}>
                {detailsBtnText}
            </button>
            <div className="px-2"></div>
            <button className="btn-navbar me-2"  onClick={handleAccept}>
                Aceptar
            </button>
        </div>
    );
};

const styles = {
    text: {
        flex: 1,
    },
};

export default CookieNoticeContainer;
